import React, {useContext} from "react"
import PickStatusView from "./PickStatus";
import Row from "@amzn/meridian/row";
import {PickContext} from "./context/PickContext";

const PickOverAllStatus = () => {
    const {viewModel} = useContext(PickContext)
    return (
        <div>
            <Row widths={["grid-3", "grid-3", "grid-3", "grid-3"]} spacingInset="medium large none large">
                <PickStatusView pickStatus={{
                    title: "pickStatus.totalPackages",
                    message: "Total Packages",
                    value: viewModel.totalPackages
                }}/>
                <PickStatusView pickStatus={{
                    title: "pickStatus.routesNotAssigned",
                    message: "Routes not assigned",
                    value: viewModel.routeNotAssigned
                }}/>
                <PickStatusView pickStatus={{
                    title: "pickStatus.sidelinePackages",
                    message: "Sidelined Packages",
                    value: viewModel.sidelinedPackages
                }}/>
            </Row>
        </div>
    )
}

export default PickOverAllStatus


// WEBPACK FOOTER //
// ./src/components/pickStatus/PickOverAllStatus.js